import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import { SupplierCreateRequest } from '@ms-organization-entities';
import { description_min_rows, PATTERN_VALIDATOR_KEY, PHONE_REGEX, REQUIRED_VALIDATOR_KEY } from '@pt/pt-models';
import * as DocumentsUtils from '../documents/utils/validator-generator';

@Component({
  selector: 'pt-create-supplier-dialog',
  template: `
    <div class='modal-header'>
      <h4 class='modal-title'>
        {{ "TITLE.CREATE_SUPPLIER" | translate }}
      </h4>
    </div>
    <div class='modal-body'>
      <form *ngIf='formGroup' [formGroup]='formGroup'>
        <pt-input-text
          [controlName]='"name"'
          formControlName='name'
          [label]="'LABELS.NAME' | translate"
          [validators]='[REQUIRED]'
        ></pt-input-text>

        <pt-input-phone
          [controlName]='"phone"'
          formControlName='phone'
          [label]="'LABELS.PHONE' | translate"
          [validators]='[PATTERN_PHONE]'
        ></pt-input-phone>
      </form>
    </div>

    <div class='modal-footer'>
      <button type='button' class='btn btn-primary btn-sm'
              [disabled]='formGroup?.invalid'
              (click)='confirm()'>
        {{ 'BUTTON.CREATE' | translate }}
      </button>
      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false)'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>
  `
})
export class CreateSupplierDialogComponent implements OnInit, OnDestroy {

  public formGroup: FormGroup;
  public descriptionMinRows = description_min_rows;
  public REQUIRED = DocumentsUtils.ValidatorGenerator.generateWidgetValidator(REQUIRED_VALIDATOR_KEY);
  public PATTERN_PHONE = DocumentsUtils.ValidatorGenerator.generateWidgetValidator(PATTERN_VALIDATOR_KEY, [PHONE_REGEX]);

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(public activeModal: NgbActiveModal) {
  }


  ngOnInit(): void {
    this.formGroup = new FormGroup({
      name: new FormControl(null),
      phone: new FormControl(null),
      vatNumber: new FormControl(null)
    });
  }

  confirm() {
    const request: SupplierCreateRequest = {
      name: this.formGroup.controls.name.value,
      phone: this.formGroup.controls.phone.value
    };

    this.activeModal.close(request);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

}
